import React from 'react';
import PropTypes from 'prop-types';

import { buildFormSections, formShape } from '../../utils';

import QuizResultsQuestion from './QuizResultsQuestion';

import './QuizResults.scss';

const propTypes = {

	/**
	 * The quiz form to display.
	 */
	form: formShape.isRequired,

	/**
	 * The quiz form entry for the current user.
	 */
	formEntry: PropTypes.shape({

		/**
		 * The form entry ID.
		 */
		id: PropTypes.string.isRequired,

		/**
		 * The list of form values for the form entry.
		 */
		form_values: PropTypes.arrayOf(PropTypes.shape({

			id: PropTypes.string.isRequired,

		})).isRequired,

	}).isRequired,

	/**
	 * True, if the quiz results should include the correct answers.
	 */
	showCorrectAnswers: PropTypes.bool,

	/**
	 * True, if the quiz results should include the customized feedback.
	 */
	showFeedback: PropTypes.bool,

};

/**
 * Shared component to render the quiz results for a specific form entry.
 *
 * @param {Object} props The props.
 * @returns {Object} The rendered component.
 */
const QuizResults = (props) => {

	const {
		form,
		formEntry,
		showCorrectAnswers,
		showFeedback,
	} = props;

	// Parse the form to build the ordered list of form sections with nested fields
	const formSections = buildFormSections(form);

	const formFields = formSections.reduce((fields, section) => {
		return fields.concat(section.fields);
	}, []);

	// Get the list of form values for the form entry
	const formValues = formEntry?.form_values || [];

	const formValuesByFieldID = {};

	// Create map of the form values by form field ID for the form entry
	for (let i = 0, len = formValues.length; i < len; i++) {
		formValuesByFieldID[formValues[i].form_field_id] = formValues[i];
	}

	return (
		<div className="tc-quiz-display-results-container">
			{formFields.map((item) => (
				<QuizResultsQuestion
					key={item.id}
					formField={item}
					formValue={formValuesByFieldID[item.id]}
					showCorrectAnswers={showCorrectAnswers}
					showFeedback={showFeedback} />
			))}
		</div>
	);

};

QuizResults.propTypes = propTypes;

export default QuizResults;
